import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {OptionModel} from '../models/option-model';
import {DeviceDataService} from './device-data.service';
import {ShareService} from "./share.service";

@Injectable({
  providedIn: 'root'
})
export class PumpPressureSensorIdService implements OnDestroy {

  private readonly allSensorIdOptionsSubject: BehaviorSubject<OptionModel[]> = new BehaviorSubject<OptionModel[]>(undefined);
  public readonly allSensorIdOptionsSubject$: Observable<OptionModel[]> = this.allSensorIdOptionsSubject.asObservable();

  private readonly pumpSensorIdOptionsSubject: BehaviorSubject<OptionModel[]> = new BehaviorSubject<OptionModel[]>(undefined);
  public readonly pumpSensorIdOptionsSubject$: Observable<OptionModel[]> = this.pumpSensorIdOptionsSubject.asObservable();

  private readonly pressureSensorIdOptionsSubject: BehaviorSubject<OptionModel[]> = new BehaviorSubject<OptionModel[]>(undefined);
  public readonly pressureSensorIdOptionsSubject$: Observable<OptionModel[]> = this.pressureSensorIdOptionsSubject.asObservable();

  private deviceDataSubscription: Subscription;

  constructor(
    private deviceDataService: DeviceDataService,
    private shareService: ShareService,
  ) {
    this.deviceDataSubscription = this.deviceDataService.deviceData$.subscribe(async data => {
      const sensorIdOptions: OptionModel[] = [];
      if (data?.deviceData?.uvsModule?.length > 0) {
        for (const module of data.deviceData.uvsModule) {
          if (module.currentLoop?.length > 0) {
            for (let i = 1; i <= module.currentLoop.length; i++) {
              sensorIdOptions.push({value: module.moduleInfo.address + '.' + i, disabled: false});
            }
          }
        }
      }
      this.allSensorIdOptionsSubject.next(sensorIdOptions);
      const otherSensors = this.shareService.sensorsOther;
      if (otherSensors?.pressureSensors?.length > 0) {
        const pressureSensorIdOptions = [];
        otherSensors.pressureSensors.forEach(sensor => {
          pressureSensorIdOptions.push({value: sensor.sensorId});
        });
        this.pressureSensorIdOptionsSubject.next(pressureSensorIdOptions);
      }
      const pumpSensors = await this.shareService.sensorsPump;
      if (pumpSensors?.pumpSensors.length > 0) {
        const pumpSensorIdOptions = [];
        pumpSensors.pumpSensors.forEach(sensor => {
          pumpSensorIdOptions.push({value: sensor.sensorId});
        });
        this.pumpSensorIdOptionsSubject.next(pumpSensorIdOptions);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.deviceDataSubscription) {
      this.deviceDataSubscription.unsubscribe();
    }
  }

  public getMaxNumberOfSingles(): number {
    const sensorIdOptions = this.allSensorIdOptionsSubject.value;
    return sensorIdOptions?.length > 0 ? this.allSensorIdOptionsSubject.value.length : 0;
  }

  public setPumpSensorIdOptions(sensorIdOptions: OptionModel[]): void {
    this.pumpSensorIdOptionsSubject.next(sensorIdOptions);
  }

  public getPumpSensorIdOptions(): OptionModel[] {
    const allAvailableSensorIdOptions = [];
    if (this.allSensorIdOptionsSubject.value?.length > 0) {
      this.allSensorIdOptionsSubject.value.forEach(option => {
        allAvailableSensorIdOptions.push(option);
      });
    }

    const pressureSensorIdOptions = this.pressureSensorIdOptionsSubject.value;
    if (pressureSensorIdOptions?.length > 0) {
      pressureSensorIdOptions.forEach(option => {
        const index = allAvailableSensorIdOptions.findIndex(sensorIdOption => sensorIdOption.value === option.value);
        if (index > -1) {
          allAvailableSensorIdOptions.splice(index, 1);
        }
      });
    }

    return allAvailableSensorIdOptions;
  }

  public setPressureSensorIdOptions(sensorIdOptions: OptionModel[]): void {
    this.pressureSensorIdOptionsSubject.next(sensorIdOptions);
  }

  public getPressureSensorIdOptions(): OptionModel[] {
    const allAvailableSensorIdOptions = [];
    if (this.allSensorIdOptionsSubject.value?.length > 0) {
      this.allSensorIdOptionsSubject.value.forEach(option => {
        allAvailableSensorIdOptions.push(option);
      });
    }

    const pumpSensorIdOptions = this.pumpSensorIdOptionsSubject.value;
    if (pumpSensorIdOptions?.length > 0) {
      pumpSensorIdOptions.forEach(option => {
        const index = allAvailableSensorIdOptions.findIndex(sensorIdOption => sensorIdOption.value === option.value);
        if (index > -1) {
          allAvailableSensorIdOptions.splice(index, 1);
        }
      });
    }

    return allAvailableSensorIdOptions;
  }
}
